import { Link } from 'react-router-dom'
import { FaTools, FaLayerGroup, FaMobileAlt, FaDesktop } from 'react-icons/fa'
import TypeWriter from '../components/TypeWriter'
import GlowCard from '../components/GlowCard'
import ScrollReveal from '../components/ScrollReveal'
import './Home.css'

function Home() {
  const features = [
    {
      icon: <FaTools />,
      title: '实用工具',
      description: '常用的开发工具和实用功能，提升工作效率',
      path: '/tools',
      platforms: ['desktop', 'mobile']
    },
    {
      icon: <FaLayerGroup />,
      title: 'UI 组件',
      description: '可复用的 React 组件库，快速构建界面',
      path: '/components',
      platforms: ['desktop', 'mobile']
    }
  ]

  const renderPlatformIcons = (platforms) => {
    return (
      <div className="platform-icons">
        {platforms.includes('desktop') && (
          <span className="platform-icon" title="支持电脑端">
            <FaDesktop />
          </span>
        )}
        {platforms.includes('mobile') && (
          <span className="platform-icon" title="支持移动端">
            <FaMobileAlt />
          </span>
        )}
      </div>
    )
  }

  return (
    <div className="home">
      <ScrollReveal direction="down" delay={0}>
        <section className="hero">
          <h1 className="hero-title">
            <TypeWriter text="All in One" speed={150} delay={300} />
          </h1>
          <p className="hero-subtitle">
            个人常用的 Web 功能集合
          </p>
          <p className="hero-description">
            包含实用工具和可复用组件，支持电脑端和移动端使用
          </p>
          <div className="hero-actions">
            <Link to="/tools" className="btn btn-primary">开始探索</Link>
            <Link to="/components" className="btn btn-secondary">查看组件</Link>
          </div>
        </section>
      </ScrollReveal>

      <ScrollReveal direction="up" delay={200}>
        <section className="features">
          <h2 className="section-title">功能模块</h2>
          <div className="feature-grid">
            {features.map((feature, index) => (
              <ScrollReveal key={index} direction="up" delay={300 + index * 100}>
                <GlowCard className="feature-card-wrapper">
                  <Link to={feature.path} className="feature-card">
                    <div className="feature-icon">{feature.icon}</div>
                    <h3 className="feature-title">{feature.title}</h3>
                    <p className="feature-description">{feature.description}</p>
                    {renderPlatformIcons(feature.platforms)}
                  </Link>
                </GlowCard>
              </ScrollReveal>
            ))}
          </div>
        </section>
      </ScrollReveal>

      <ScrollReveal direction="up" delay={400}>
        <section className="platform-info">
          <h2 className="section-title">平台支持说明</h2>
          <div className="platform-cards">
            <ScrollReveal direction="left" delay={500}>
              <div className="platform-card">
                <FaDesktop className="platform-card-icon" />
                <h3>电脑端</h3>
                <p>支持完整的键盘操作和大屏界面</p>
              </div>
            </ScrollReveal>
            <ScrollReveal direction="right" delay={600}>
              <div className="platform-card">
                <FaMobileAlt className="platform-card-icon" />
                <h3>移动端</h3>
                <p>适配触控操作和小屏界面</p>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </ScrollReveal>
    </div>
  )
}

export default Home